import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Chip from '@mui/material/Chip';
import CheckCircleIcon from '@mui/icons-material/Check';
import PendingIcon from '@mui/icons-material/Pending';
import Tooltip from '@mui/material/Tooltip';

import { theme } from "../../../../theme";
import Context from "../context";
import { fullDateFormat } from "../../../../utils";

const RecallVisitInfo = ({ show, closeFun }) => {
    const context = useContext(Context);

    return (
        <Modal
            show={show}
            onHide={closeFun}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body>
                <div className="card mb-3 mt-lg-0 mt-4 card-plain">
                    <div className="card-body pb-0">
                        <div className="row align-items-center mb-3">
                            <div className="col-9">
                                <h5 className={`mb-1 text-gradient text-${theme.main}`}>
                                    Recall Visit
                                </h5>
                            </div>
                        </div>
                        <p></p>
                        <div className="table-responsive">
                            <table className="table align-items-center mb-0">
                                <tbody>
                                    {[
                                        {
                                            title: "Customer",
                                            value: context.state.recall_visit_info?.job?.customer?.customer_full_name
                                        },
                                        {
                                            title: "Create date",
                                            value: fullDateFormat(context.state.recall_visit_info?.re_call_visit_created_at)
                                        },
                                        {
                                            title: "Tradespersons",
                                            value: context.state.recall_visit_info?.job?.ftm?.ftm_forename + " " + context.state.recall_visit_info?.job?.ftm?.ftm_surname
                                        },
                                        {
                                            title: "Job ID",
                                            value: context.state.recall_visit_info?.re_call_visit_job_id
                                        },
                                        {
                                            title: "Dispute ID",
                                            value: context.state.recall_visit_info?.re_call_visit_dispute_id
                                        },
                                        {
                                            title: "Visit Type",
                                            value: <Chip 
                                                        label={context.state.recall_visit_info?.re_call_visit_paid_type === 1 ? "PAID" : "FREE"} 
                                                        color={context.state.recall_visit_info?.re_call_visit_paid_type === 1 ? "warning" : "default"}
                                                        size="small"
                                                    />,
                                        },
                                    ].map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="d-flex px-2 py-0">
                                                    <div className="d-flex flex-column justify-content-center">
                                                        <h6 className="mb-0 text-sm">{item.title}</h6>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="align-middle text-right text-sm">
                                                <span className="text-sm"> {item.value} </span>
                                            </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td>
                                            <div className="d-flex px-2 py-0">
                                                <div className="d-flex flex-column justify-content-center">
                                                    <h6 className="mb-0 text-sm">Approved By</h6>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <span className="text-sm">
                                                <Tooltip title={context.state.recall_visit_info?.re_call_visit_approval_by_ftm === 1 ? "Approved" : "Pending Approval"} arrow>
                                                    <Chip icon={context.state.recall_visit_info?.re_call_visit_approval_by_ftm === 1 ? <CheckCircleIcon /> : <PendingIcon />} label="Tradesperson" color={context.state.recall_visit_info?.re_call_visit_approval_by_ftm === 1 ? "success" : "default"} size="small" style={{ marginRight: '8px' }} />
                                                </Tooltip>
                                                <Tooltip title={context.state.recall_visit_info?.re_call_visit_approval_by_customer === 1 ? "Approved" : "Pending Approval"} arrow>
                                                    <Chip icon={context.state.recall_visit_info?.re_call_visit_approval_by_customer === 1 ? <CheckCircleIcon /> : <PendingIcon />} label="Customer" color={context.state.recall_visit_info?.re_call_visit_approval_by_customer === 1 ? "success" : "default"} size="small" />
                                                </Tooltip>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant={theme.close_btn} onClick={closeFun} size="sm">
                    CLOSE
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RecallVisitInfo;
